export const STATUS_NOT_FOUND = "not-found";
export const STATUS_PENDING = "pending";
export const STATUS_ABORTED = "aborted";
export const STATUS_REJECTED = "rejected";
export const STATUS_RESOLVED = "resolved";
